import * as React from 'react';

type Props = {
  value: any;
  is: any;
};

const When = ({ value, is, children }: React.PropsWithChildren<Props>): any => {
  if (value === undefined && is === true) {
    return children;
  }
  if (value === is) {
    return children;
  }
  return null;
};

export default When;
